import { render, staticRenderFns } from "./SearchDiseasePage.vue?vue&type=template&id=a7f89552&scoped=true&"
import script from "./SearchDiseasePage.vue?vue&type=script&lang=js&"
export * from "./SearchDiseasePage.vue?vue&type=script&lang=js&"
import style0 from "./SearchDiseasePage.vue?vue&type=style&index=0&id=a7f89552&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f89552",
  null
  
)

export default component.exports